import { emptyState } from './engine';
let opening;
function open() {
  if (!opening) opening = new Promise((resolve, reject) => {
    const request = indexedDB.open('node-offline-v1', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('scopes');
    request.onsuccess = () => {
      request.result.onversionchange = () => { request.result.close(); opening = null; };
      resolve(request.result);
    };
    request.onerror = () => { opening = null; reject(request.error); };
    request.onblocked = () => { opening = null; reject(new Error('OFFLINE_DATABASE_BLOCKED')); };
  });
  return opening;
}
export function createStorage(scope) {
  return {
    async read() {
      const database = await open();
      return new Promise((resolve, reject) => {
        const tx = database.transaction('scopes', 'readonly');
        const request = tx.objectStore('scopes').get(scope);
        request.onsuccess = () => resolve(request.result || emptyState());
        request.onerror = () => reject(request.error);
      });
    },
    async mutate(fn) {
      const database = await open();
      return new Promise((resolve, reject) => {
        const tx = database.transaction('scopes', 'readwrite');
        const store = tx.objectStore('scopes');
        let failure;
        const request = store.get(scope);
        request.onsuccess = () => {
          try {
            const state = request.result || emptyState();
            if (state.schema !== 1) throw new Error('OFFLINE_DATABASE_UPGRADE_REQUIRED');
            fn(state); store.put(state, scope);
          } catch (error) { failure = error; tx.abort(); }
        };
        tx.oncomplete = () => resolve();
        tx.onabort = tx.onerror = () => reject(failure || tx.error || new Error('OFFLINE_STORAGE_FAILED'));
      });
    },
  };
}
